import { render, staticRenderFns } from "./SupplierRawMaterialSolvents.vue?vue&type=template&id=f8666032&scoped=true&"
import script from "./SupplierRawMaterialSolvents.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialSolvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8666032",
  null
  
)

export default component.exports